export default "__VITE_ASSET__DdmFxgJW__"